<ng-template #manageEsimModalFormMore role="document" let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="moreFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="moreFormSubmit()" [formGroup]="moreForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      <div class="row">
        <div class="col-5">
          <div class="mb-3 px-2">
            <label for="alertProduct-field" class="form-label">Active Alert Product</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-3 px-2">
            <input readonly type="text" id="alertProduct-field" class="form-control text-end border-0" style="padding-top: 0px;" placeholder="" formControlName="alertProduct" data-lpignore="true" />
          </div>
        </div>
      </div>
          
      <!-- <div class="row">
        <div class="col-12">
          <div class="mb-1">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}}" role="alert">
              <strong>Information</strong> - <span [innerHtml]="progressInformation" ></span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-3">
          <div class="mb-1">
            <label for="username-field" class="form-label">Username</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-1">
            <input readonly type="text" id="username-field" class="form-control text-end border-0" placeholder="" formControlName="username" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>

      <div class="row">
        <div class="col-1"></div>
        <div class="col-3">
          <div class="mb-1">
            <label for="orderNo-field" class="form-label">Order No</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-1">
            <input readonly type="text" id="orderNo-field" class="form-control text-end border-0" placeholder="" formControlName="orderNo" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div> -->
      
      <!-- <div class="row">
        <div class="col-1"></div>
        <div class="col-3">
          <div class="mb-3">
            <label for="iccid-field" class="form-label">ICCID</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-3">
            <input readonly type="text" id="iccid-field" class="form-control text-end border-0" placeholder="" formControlName="iccid" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div> -->
      
      <!-- <div class="row">
        <div class="col-2"></div>
        <div class="col-8 mb-1">
          <div class="d-grid gap-2">
            <button type="button" id="suspendButton" class="btn btn-soft-primary inline-block" [ngClass]="{ 'btn-soft-danger': highlightBtnSuspend }" (click)="suspend()" (mouseover)="suspendMouseOver()" (mouseleave)="suspendMouseLeave()">Suspend</button>
          </div>
        </div>
        <div class="col-2"></div>
      </div> -->
      
      <!-- <div class="row">
        <div class="col-2"></div>
        <div class="col-8 mb-1">
          <div class="d-grid gap-2">
            <button type="button" id="enableButton" class="btn btn-soft-primary inline-block" [ngClass]="{ 'btn-soft-success': highlightBtnEnable }" (click)="enable()" (mouseover)="enableMouseOver()" (mouseleave)="enableMouseLeave()">Unsuspend</button>
          </div>
        </div>
        <div class="col-2"></div>
      </div> -->

      <div class="row">
        <div class="col-2"></div>
        <div class="col-8 mb-1">
          <div class="d-grid gap-2">
            <button type="button" 
                    id="removeAlertProductButton" 
                    class="btn btn-soft-primary inline-block" 
                    [disabled]="sureSimOrderDetails?.alertProduct == '' || sureSimOrderDetails?.alertProduct == 'No'"
                    [ngClass]="{ 'btn-soft-success': highlightBtnEnable }" 
                    (click)="removeAlertProduct()" 
                    (mouseover)="removeAlertProductMouseOver()" (mouseleave)="removeAlertProductMouseLeave()">Remove Alert Product</button>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8 mb-1">
          <div class="d-grid gap-2">
            <button type="button" id="changeLimitsButton" class="btn btn-soft-primary inline-block" [disabled]="!limitChangeButtonEnabled" [ngClass]="{ 'btn-soft-success': highlightBtnChangeLimits }" (click)="changeLimits()" (mouseover)="changeLimitsMouseOver()" (mouseleave)="changeLimitsMouseLeave()">Change Limits</button>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8 mb-3">
          <div class="d-grid gap-2">
            <button type="button" id="deleteSimButton" class="btn btn-soft-primary inline-block" [ngClass]="{ 'btn-soft-danger': highlightBtnDeleteSim }" (click)="deleteSim()" (mouseover)="deleteSimMouseOver()" (mouseleave)="deleteSimMouseLeave()">Cease SureSIM</button>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      
      @if(showMessagingArea) {
        <div class="row">
          <div class="col-12">
                                  
            <div class="border border-success rounded">
              <div class="row">
                <div class="col-12">
                  <div class="alert border-0 alert-primary" role="alert">
                    <strong>Message User</strong>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="mb-1 px-2">
                    <!-- <label for="messageInput" class="form-label">Message</label> -->
                    <textarea class="form-control" id="messageInput" formControlName="messageInput" data-lpignore="true" rows="5" placeholder=""></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4 mb-2 text-end">
                  <button type="button" id="smsUserButton" class="btn btn-soft-primary" [ngClass]="{ 'btn-soft-success': highlightBtnSmsUser }" (click)="smsUser()" (mouseover)="smsUserMouseOver()" (mouseleave)="smsUserMouseLeave()">SMS</button>
                </div>
                <div class="col-4 mb-2 text-center">
                  <button type="button" id="emailUserButton" class="btn btn-soft-primary" [ngClass]="{ 'btn-soft-success': highlightBtnEmailUser }" (click)="emailUser()" (mouseover)="emailUserMouseOver()" (mouseleave)="emailUserMouseLeave()">Email</button>
                </div>
                <div class="col-4 mb-2 text-start">
                  <button type="button" id="notifyUserButton" class="btn btn-soft-primary" [ngClass]="{ 'btn-soft-success': highlightBtnNotifyUser }" (click)="notifyUser()" (mouseover)="notifyUserMouseOver()" (mouseleave)="notifyUserMouseLeave()">Notify</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

    <div class="row">
      <div class="col-12">
        <div class="hstack gap-2 justify-content-center">
          @if(this.deprovisionInProgress) {
            <lord-icon
              colors="primary:#121331,secondary:#08a88a"
              src="https://cdn.lordicon.com/kbtmbyzy.json"
              style="width: 75px; height: 75px;"
              trigger="loop"
            ></lord-icon>
          }
        </div>
      </div>
    </div>

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="moreFormCancel()">Close</button>
        <!-- <button type="submit" [disabled]="!submitButtonEnabled" class="btn btn-success" id="add-btn">Submit</button> -->
      </div>
    </div>
  </form>    
</ng-template>

<app-confirmation-modal-form #deleteSimConfirmationModal
  (modalYes)="yesDeleteSim()"
></app-confirmation-modal-form>

<app-usage-limits-modal-form #usageLimitsModalForm
  [dontShowSubmittedWarning]="true"
  (dataHasBeenSaved)="usageLimitsModalFormSaved($event)"
  (usageLimitsFormCancelled)="usageLimitsModalFormHasBeenCancelled()"
></app-usage-limits-modal-form>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>